export const SET_SHOW = "DIALOG/SET_SHOW";
export const SET_IMAGES = "DIALOG/SET_IMAGES";
export const SET_ITEM = "DIALOG/SET_ITEM";
